export default __webpack_public_path__ + "static/media/sec3.0bac8c56.svg";